import { useQuery } from '@tanstack/react-query';

import { contactsApi } from '@/api/services/contacts.api';

/**
 * Resolve "is this number saved as a contact?" by exact E.164 match —
 * independent of whether old call rows were ever linked to the contact.
 * Keyed under the `['contacts']` family so contact CRUD invalidations
 * (including the widget's own save mutations) refresh it.
 */
export function useContactByPhone(phone: string, enabled = true) {
    return useQuery({
        queryKey: ['contacts', 'by-phone', phone],
        queryFn: async () => {
            const { data } = await contactsApi.list({ search: phone, limit: 5 });
            return data.find((contact) => contact.phone === phone) ?? null;
        },
        enabled: enabled && Boolean(phone),
        staleTime: 30_000,
    });
}
